import { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import lerp from '@14islands/lerp';
import type { SceneProps } from '.';
import type * as THREE from 'three';

export function MainShadow(props: SceneProps) {
	const floorRef = useRef<THREE.Mesh | null>(null);

	const animation = useRef<{ delay: number; status: 'none' | 'started' }>({ delay: 0, status: 'none' }).current;

	useFrame((_, delta) => {
		if (window && floorRef.current) {
			if (props.modelsInfo.activeProduct && floorRef.current.material['opacity'] !== 0) {
				floorRef.current.material['opacity'] = lerp(floorRef.current.material['opacity'], 0, 0.1, delta * 3);
				floorRef.current.renderOrder = 10;
			}

			if (!props.modelsInfo.activeProduct && floorRef.current.material['opacity'] !== 0.75) {
				if (animation.status === 'none') animation.status = 'started';
				if (animation.delay < 0.5) animation.delay += delta;
				else floorRef.current.material['opacity'] = lerp(floorRef.current.material['opacity'], 0.75, 0.1, delta * 3);

				floorRef.current.renderOrder = 0;
			} else {
				animation.delay = 0;
				animation.status = 'none';
			}
		}
	});

	return <>{props.scene && <primitive ref={floorRef} {...{ position: [0, 0, 0], object: props.scene.Floor }} />}</>;
}
